import { css } from '@emotion/css';
import { AlignItems, Display, JustifyContent } from 'src/styles';

export const container = (height: string) =>
  css`
    height: ${height};
    ${AlignItems.center}
    ${JustifyContent.center}
    ${Display.flex}
  `;
